/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_ContextInputs */

const en_wb_operations_context = /** @type {(inputs: Wb_Operations_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incoming order`)
};

const lv_wb_operations_context = /** @type {(inputs: Wb_Operations_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ienākošs pasūtījums`)
};

/**
* | output |
* | --- |
* | "Incoming order" |
*
* @param {Wb_Operations_ContextInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_context = /** @type {((inputs?: Wb_Operations_ContextInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_ContextInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_context(inputs)
	return en_wb_operations_context(inputs)
});